import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-0be68d3a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "question-header"
};
var _hoisted_3 = {
  key: 0,
  class: "question-image-box"
};
var _hoisted_4 = {
  class: "question-content"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "left-content"
};
var _hoisted_7 = {
  class: "right-content"
};
var _hoisted_8 = {
  class: "choice-content"
};
var _hoisted_9 = {
  key: 0,
  class: "title-success"
};
var _hoisted_10 = {
  key: 1,
  class: "title-error"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CustomAudio = _resolveComponent("CustomAudio");
  var _component_Image = _resolveComponent("Image");
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_row = _resolveComponent("a-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.question.audioUrl ? (_openBlock(), _createBlock(_component_CustomAudio, {
    key: 0,
    audioUrl: _ctx.question.audioUrl
  }, null, 8, ["audioUrl"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.question.content), 1)]), _ctx.question.picUrl ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_Image, {
    src: _ctx.question.picUrl,
    alt: "question image"
  }, null, 8, ["src"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_row, {
    type: "flex",
    gutter: 16
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.options, function (option, index) {
        return _openBlock(), _createBlock(_component_a_col, {
          span: 24 / _ctx.question.columns,
          key: index,
          style: {
            "margin-bottom": "16px"
          }
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", {
              class: _normalizeClass(["question-content-box", option.checked]),
              onClick: function ($event) {
                return _ctx.onOptionCheck(index, option);
              }
            }, [_createElementVNode("div", _hoisted_6, [option.audioUrl ? (_openBlock(), _createBlock(_component_CustomAudio, {
              key: 0,
              audioUrl: option.audioUrl
            }, null, 8, ["audioUrl"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.numberToLetter(index)) + ".", 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(option.content), 1), option.picUrl ? (_openBlock(), _createBlock(_component_Image, {
              key: 0,
              src: option.picUrl,
              alt: "option image"
            }, null, 8, ["src"])) : _createCommentVNode("", true)])], 10, _hoisted_5)];
          }),
          _: 2
        }, 1032, ["span"]);
      }), 128))];
    }),
    _: 1
  })]), _ctx.answerMode && _ctx.currentPaperAnswer ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['question-answer-container', _ctx.isUserAnswerRight ? 'question-answer-container-success' : 'question-answer-container-error'])
  }, [_ctx.isUserAnswerRight ? (_openBlock(), _createElementBlock("span", _hoisted_9, "回答正确")) : (_openBlock(), _createElementBlock("span", _hoisted_10, "回答错误")), _createElementVNode("span", null, "正确答案：" + _toDisplayString(_ctx.currentPaperAnswer), 1)], 2)) : _createCommentVNode("", true)]);
}